import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

type handler = () => void;
interface settingsProps {
  visible: boolean;
  toggleVisible: handler;
}
const Settings = (props: settingsProps) => {
  
  
  useEffect(() => {
  }, [props.visible]);
 
  


  const renderDialog = () => {
    if (props.visible) {
     
      return (
        <Dialog title={"Settings"} onClose={props.toggleVisible} width={600}>
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              height: "300px",
              overflowY: "scroll",
            }}
          >
        </div>
          <DialogActionsBar>
           

            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={props.toggleVisible}
            >
              Close
            </button>
          </DialogActionsBar>
        </Dialog>
      );
    }
    return null;
  };
  return renderDialog();
};

export default Settings;
